import { NgZone, } from '@angular/core';
import { AppStateFacade, Setting, } from '@app-state';
import { PageMetadataRegistry, } from '@app/router';
import { filterNullOrUndefined } from '@utils/rxjs.utils';
import { skip } from 'rxjs/operators';
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService(document, _zone, _appState, _pageRegistry) {
        var _this = this;
        this._zone = _zone;
        this._appState = _appState;
        this._pageRegistry = _pageRegistry;
        this._window = document.defaultView;
        this._pageRegistry
            .activePage$
            // skip initial emissions
            .pipe(skip(2), filterNullOrUndefined())
            .subscribe(function (page) {
            var title = page.title;
            var parentTitle = page.parent ? page.parent.title : null;
            var currentPage = parentTitle ? parentTitle + " " + title : title;
            _this._title = currentPage || 'Dashboard';
            _this.track('Page Load');
        });
    }
    AnalyticsService.prototype.track = function (name, args) {
        var _this = this;
        this._zone.runOutsideAngular(function () {
            var argsCopy = Object.assign({}, args);
            _this._parseColumnsFilter(argsCopy);
            _this._mixPanelTrack(name, Object.assign({
                modernFolders: !!_this._appState.settings.get(Setting.isModernFolderSystemEnabled),
                language: _this._appState.language.value,
                page: _this._title,
                version: _this._appState.authConfig.buildVersion,
            }, argsCopy));
        });
    };
    AnalyticsService.prototype._mixPanelTrack = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this._window['mixpanel']) {
            this._window['mixpanel'].track.apply(this._window['mixpanel'], args);
        }
    };
    AnalyticsService.prototype._parseColumnsFilter = function (filters) {
        var columnFilters = filters['columnFilters'];
        var displayColumnFilters = [];
        if (columnFilters) {
            Object.keys(columnFilters).forEach(function (key) {
                var columnFilter = columnFilters[key];
                if (columnFilter.value === null) {
                    delete columnFilters[key];
                }
                else if (columnFilter.label) {
                    displayColumnFilters.push(columnFilter.title + " " + columnFilter.operator + " " + columnFilter.label);
                }
                else {
                    displayColumnFilters.push(columnFilter.title + " " + columnFilter.operator + " " + columnFilter.value);
                }
            });
            if (displayColumnFilters.length) {
                filters['columnFilters'] = displayColumnFilters.join('; ');
            }
            else {
                delete filters['columnFilters'];
            }
        }
    };
    return AnalyticsService;
}());
export { AnalyticsService };
